import React from 'react'
import { ModalContainer } from './styled';
import { CloseOutlined } from '@ant-design/icons';

const ModelWrapper = ({
    show,
    setShow,
    footer,
    title,
    children,
    hideIcon,
    keyClose,
    width,
    ...props
}) => {
  return (
    <>
      <ModalContainer
        closable={false}
        maskClosable = {false}
        title={
          title && (
            <div className="d-flex align-start justify-start" style={{padding: "15px"}}>
              {title}
              {!hideIcon && (
                <span
                  className="close-icon"
                >
                  <CloseOutlined onClick={() => setShow(false)} />
                </span>
              )}
            </div>
          )
        }
        centered
        open={show}
        onOk={() => setShow(false)}
        onCancel={() => setShow(false)}
        footer={footer}
        {...props}
        keyboard={keyClose ? false : true}
        width={width}

      >
        {children}
      </ModalContainer>
    </>
  );
};

export default ModelWrapper;
